import Props from "./Props";

const ENV: Props = {
	API_URL: "https://service.staging.ridevu.com",
	MASTER_API_KEY: "75-5-ab2ef",
	SENTRY_LOG_URL: "https://57b844f9bd4649acb4af143f8dd52e34@o4504099501178880.ingest.sentry.io/4504099504848897",
	UNLEASH_PROXY_URL: "https://unleash-proxy.staging.privilegemovies.com/proxy",
	UNLEASH_AUTH_KEY: "Jjt8tXNa83t6i89o9XxNQbGhxvBRB2m4",
	MAINTENANCE_CONFIG_URL: "https://cf.privilegemovies.com/remote-config/staging.json",
	MOBILE_PAYMENT_URL: "https://payments.staging.ridevu.com/purchase",
	PINPOINT_REGION: "us-east-2",
	PINPOINT_APP_ID: "ridevumbz-staging",
	PINPOINT_WEB_CLIENT_ID: "aea9327ecce7492a8025ce2fbd4d6236",
	PINPOINT_USER_POOL_ID: "us-east-2_aea9327ecce7492a8025ce2fbd4d6236",
	PINPOINT_IDENTITY_POOL_ID: "us-east-2:5df2e25c-f8d9-4d88-b3ff-ff678bc3a121",
};

export default ENV;
